<template>
  <div class="d-flex align-center justify-space-between mb-3">
    <div class="d-flex flex-column">
      <div class="d-flex align-center ga-1">
        <span class="font-weight-bold d-block font-size-15">
          Типи документів
        </span>
        <span class="text-disabled font-size-13">
          ({{ journalSource.docTypeDefinitions?.length }})
        </span>
      </div>
      <span class="text-disabled">
        Типи документів, які використовують цей журнал
      </span>
    </div>
    <entity-select-menu
      :selected-items="journalSource.docTypeDefinitions"
      directory-key="docTypeDefinitions"
      @select-item="addDefinition"></entity-select-menu>
  </div>
  <div v-if="journalSource.docTypeDefinitions?.length">
    <v-card
      v-for="definition in journalSource.docTypeDefinitions"
      :key="definition.id"
      border>
      <v-card-text>
        <div class="d-flex align-center justify-space-between">
          <div class="d-flex align-center ga-2">
            <div class="icon--blue">
              <v-icon icon="mdi-file-outline" size="23"></v-icon>
            </div>
            <span class="font-size-14">{{ definition.name }}</span>
          </div>
          <v-btn
            :loading="
              $loading.isLoading(
                `registrationJournalDefinitionDelete_${definition.id}`
              )
            "
            border
            class="text-none"
            size="small"
            style="border-color: #ddd"
            variant="outlined"
            @click="deleteDefinition(definition.id)">
            <span class="font-weight-medium text-error"> Видалити </span>
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </div>
  <v-card v-else border color="grey-lighten-5">
    <v-card-text class="d-flex justify-center align-center py-8">
      <span class="text-disabled d-block">
        Немає прив'язаних типів документів
      </span>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import EntitySelectMenu from '@/components/inputs/EntitySelectMenu.vue'
import { useRegistrationJournal } from '../registrationJournal'
import { confirm, handleAsync, setSnackbar } from 'best-modules/plugins'
import {
  registrationJournalDefinitionCreate,
  registrationJournalDefinitionDelete,
} from '@/requests/registrationJournal'
import { RegistrationJournalDefinition } from '@/utils/types/registrationJournal'

export default {
  name: 'RegistrationJournalDefinitions',
  components: { EntitySelectMenu },
  setup() {
    const { journalSource, journalId } = useRegistrationJournal()

    const addDefinition = (item: RegistrationJournalDefinition) => {
      return registrationJournalDefinitionCreate(journalId.value, item.id).then(
        res => {
          journalSource.docTypeDefinitions = res.docTypeDefinitions
          setSnackbar({ text: 'Тип документа додано до журналу' })
        }
      )
    }

    const deleteDefinition = (definitionId: number) => {
      confirm({
        text: 'Ви дійсно бажаєте видалити тип документа з журналу реєстрацій?',
      }).then(() => {
        return handleAsync(
          `registrationJournalDefinitionDelete_${definitionId}`,
          () => {
            return registrationJournalDefinitionDelete(
              journalId.value,
              definitionId
            ).then(res => {
              if (res) {
                journalSource.docTypeDefinitions = res.docTypeDefinitions
                setSnackbar({ text: 'Тип документа видалено з журналу' })
              }
            })
          }
        )
      })
    }

    return {
      addDefinition,
      deleteDefinition,
      journalSource,
    }
  },
}
</script>

<style lang="scss" scoped></style>
